export const AclNonGitResourceType = {
  User: 'user',
  Team: 'team',
  AccessToken: 'api_key',
  Org: 'organization',
  Space: 'space',
} as const;
export type AclNonGitResourceType = (typeof AclNonGitResourceType)[keyof typeof AclNonGitResourceType];

export const AclAssetModuleResourceType = {
  Integrations: 'integrations',
  Models: 'models',
  Visualizations: 'visualizations',
  Orchestrations: 'orchestrations',
  DataContracts: 'data_contracts',
  DataExports: 'data_exports',
  Alerts: 'alerts',
  Lineage: 'lineage',
} as const;
export type AclAssetModuleResourceType = (typeof AclAssetModuleResourceType)[keyof typeof AclAssetModuleResourceType];

export const AclAssetResourceType = {
  Integration: 'integration',
  UIModel: 'ui_model',
  SQLModel: 'sql_model',
  VisualizationDashboard: 'dashboard',
  VisualizationDashboardWidget: 'widget',
  Export: 'export',
  DataContract: 'data_contract',
  StatusAlert: 'status_alert',
  Orchestration: 'orchestration',
  LineageSnapshot: 'snapshot',
} as const;
export type AclAssetResourceType = (typeof AclAssetResourceType)[keyof typeof AclAssetResourceType];

export const AclAssetChildResourceType = {
  Table: 'table',
  Job: 'job',
  OrchestrationRun: 'orchestration_run',
  ExportTrigger: 'export_trigger',
} as const;
export type AclAssetChildResourceType = (typeof AclAssetChildResourceType)[keyof typeof AclAssetChildResourceType];

export type AclAssetOrChildResourceType = AclAssetResourceType | AclAssetChildResourceType;

export const AclResourceType = {
  ...AclNonGitResourceType,
  ...AclAssetModuleResourceType,
  ...AclAssetResourceType,
  ...AclAssetChildResourceType,
} as const;
export type AclResourceType = (typeof AclResourceType)[keyof typeof AclResourceType];

export const AclResourceTypeToChildResourceType: Record<AclAssetResourceType, AclAssetChildResourceType | null> = {
  [AclAssetResourceType.Integration]: AclAssetChildResourceType.Table,
  [AclAssetResourceType.UIModel]: AclAssetChildResourceType.Table,
  [AclAssetResourceType.SQLModel]: AclAssetChildResourceType.Table,
  [AclAssetResourceType.VisualizationDashboard]: null,
  [AclAssetResourceType.VisualizationDashboardWidget]: null,
  [AclAssetResourceType.Export]: AclAssetChildResourceType.ExportTrigger,
  [AclAssetResourceType.DataContract]: null,
  [AclAssetResourceType.StatusAlert]: null,
  [AclAssetResourceType.Orchestration]: null,
  [AclAssetResourceType.LineageSnapshot]: null,
};

export const AclResourceTypeToAssetModuleResourceType: Record<AclAssetResourceType, AclAssetModuleResourceType> = {
  [AclAssetResourceType.Integration]: AclAssetModuleResourceType.Integrations,
  [AclAssetResourceType.UIModel]: AclAssetModuleResourceType.Models,
  [AclAssetResourceType.SQLModel]: AclAssetModuleResourceType.Models,
  [AclAssetResourceType.VisualizationDashboard]: AclAssetModuleResourceType.Visualizations,
  [AclAssetResourceType.VisualizationDashboardWidget]: AclAssetModuleResourceType.Visualizations,
  [AclAssetResourceType.Export]: AclAssetModuleResourceType.DataExports,
  [AclAssetResourceType.DataContract]: AclAssetModuleResourceType.DataContracts,
  [AclAssetResourceType.StatusAlert]: AclAssetModuleResourceType.Alerts,
  [AclAssetResourceType.Orchestration]: AclAssetModuleResourceType.Orchestrations,
  [AclAssetResourceType.LineageSnapshot]: AclAssetModuleResourceType.Lineage,
};

// TODO: Gabi, remove filter once data contracts are fully implemented
export const assetModuleValues: AclAssetModuleResourceType[] = Object.values<AclAssetModuleResourceType>(
  AclAssetModuleResourceType,
).filter((resourceType) => resourceType !== AclAssetModuleResourceType.DataContracts);

export const isAssetModuleType = (resourceType: AclResourceType): resourceType is AclAssetModuleResourceType =>
  (assetModuleValues as string[]).includes(resourceType);
